import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Group%20of%20diverse%20volunteers%20cleaning%20a%20beautiful%20sandy%20beach%20at%20sunset%2C%20carrying%20mesh%20collection%20bags%20and%20wearing%20gloves%2C%20golden%20hour%20light%20illuminating%20the%20scene%2C%20ocean%20waves%20in%20background%2C%20uplifting%20community%20action%2C%20cinematic%20warm%20tones%2C%20environmental%20photography%2C%20inspiring%20beach%20conservation%20mood&width=1600&height=700&seq=cta-beach-volunteer&orientation=landscape"
        alt="Volunteers cleaning a beach at sunset"
        className="absolute inset-0 w-full h-full object-cover"
        title="Beach cleanup volunteers in action"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-teal-900/50"></div>

      {/* Content */}
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-background-50 leading-tight">
          {t('cta.title')}
        </h2>
        <p className="mt-4 md:mt-5 text-sm md:text-base text-background-50/80 max-w-xl mx-auto leading-relaxed font-light">
          {t('cta.subtitle')}
        </p>
        <Link
          to="/donate"
          className="mt-8 md:mt-10 inline-flex items-center gap-2 px-8 py-3 md:px-10 md:py-3.5 bg-background-50 text-foreground-950 text-sm md:text-base font-semibold rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
        >
          {t('cta.button')}
          <div className="w-6 h-6 flex items-center justify-center bg-foreground-950 rounded-full">
            <i className="ri-arrow-right-line text-xs text-background-50"></i>
          </div>
        </Link>
      </div>
    </section>
  );
}